const Common = require("./pageConfig/common");
const Home = require("./pageConfig/home");
const Study = require("./pageConfig/study");
const Mine = require("./pageConfig/mine");
const Online = require("./pageConfig/online.js");
const H5Page = require("./pageConfig/H5Page.js");
const TrainingManual = require("./pageConfig/trainingManual.js");

module.exports = {
  ...Common,
  ...Home,
  ...Study,
  ...Mine,
  ...Online,
  ...H5Page,
  ...TrainingManual
};
